/*
 * JuvaBun shade help (Oct 2026). Loaded sitewide with defer from snippets/jb-head.liquid. Small, no requests.
 *
 * Why: on the old theme, shade help next to the buy box was used a lot (Clarity, 30 days on the Messy Bun page:
 * ~540 hair-color answers in the Klaviyo popup, 137 taps on the old chat prompt "Help me to chose color",
 * 86 on "Find Your Color Match!"). The new page had only a small "Find my shade" link (2 taps in 3 days).
 *
 * 1. Help card under the swatches ("Not sure which shade? ... Find my shade"), product pages with the finder.
 *    Inserted by this file into space that snippets/jb-head.liquid reserves with CSS, so nothing moves on load.
 * 2. Help bubble, in the style of the old chat prompt, shown ONCE per visit, at the moment she hesitates.
 *    Amit 2026-10-19 17:56: no timer anywhere. Only on product pages with the finder (opens the finder right there),
 *    and only after she has tapped 2 different shades by hand (comparing) -> about 1.5 s later, "Torn between shades?"
 *    (The 7 s swatch timer, the 25 s fallback and the home/collection timer were removed.)
 *    Not on: the old Messy Bun page (?view=messy-bun-control, JB35 V1), products without the finder (brush,
 *    accessories), home, collections, cart, account, the finder pages, the bundle builder. Never in the first 4 s,
 *    never while a Klaviyo form is open,
 *    never after she opened the finder or added to cart, never with a saved match (localStorage "jb-shade-match"),
 *    3 days of quiet after "no thanks", never again after 2 "no thanks".
 * 3. Klaviyo welcome popup bridge (every page). The popup "welcome popup | addz" asks the natural hair color,
 *    then email, then phone, then "TAKE THE QUIZ" redirects to /pages/color-quiz-popup.
 *    - The hair color answer is kept in sessionStorage "jb-sf-hair" (black / blonde / red / gray; brunette is too
 *      broad). When the finder opens, this file answers its first question once (it clicks the finder's own buttons,
 *      so jb-shade-finder.js is unchanged).
 *    - On a product page: "TAKE THE QUIZ", or closing the popup after giving the email, opens the finder right here
 *      instead of leaving the product. Elsewhere the redirect goes to the finder page as before.
 *
 * Tracking (Intelligems custom events, selectors only): bubble shown = element viewed [data-jb-nudge-view],
 * [data-jb-nudge="find"], [data-jb-nudge="no"]; help card = [data-jb-sfcta].
 * Storage is wrapped in try/catch; everything works without it.
 */
(() => {
  if (window.JBShadeNudge) return;
  window.JBShadeNudge = true;

  const ss = {
    get(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* ignore */ } }
  };
  const ls = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* ignore */ } }
  };
  const t0 = Date.now();

  const host = () => document.querySelector('jb-pdp[data-finder-src], jb-pdp-gen[data-finder-src]');
  const finderEl = () => { const h = host(); return h ? h.querySelector('[data-finder]') : null; };
  const hasFinder = () => { const h = host(); return !!(h && finderEl() && typeof h.openFinder === 'function'); };
  const openFinder = () => {
    const h = host();
    if (!h || typeof h.openFinder !== 'function') return false;
    hideBubble();
    ss.set('jb-nudge', '1');
    h.openFinder();
    prefill(finderEl());
    return true;
  };

  /* ------------------------------------------------ hair color from the popup -> skip question 1 */
  const NAMES = { black: 'black', blonde: 'blonde', red: 'red or auburn', gray: 'gray or silver' };
  function prefill(dialog) {
    const v = ss.get('jb-sf-hair');
    if (!dialog || !NAMES[v]) return;
    ss.set('jb-sf-hair', '');
    // dialog._finder is set by JBShadeFinder.attach(), so its buttons are wired by then
    const steps = [() => dialog._finder && dialog.querySelector('[data-sf-view="start"]:not([hidden]) [data-sf-quiz]'),
      () => dialog.querySelector(`[data-sf-view="quiz"] [data-sf-answer="${v}"]`)];
    if (v === 'gray') steps.push(() => dialog.querySelector('[data-sf-view="quiz"] [data-sf-answer="most"]'));
    let i = 0;
    let tries = 0;
    const tick = () => {
      if (++tries > 60) return;
      const el = steps[i]();
      if (!el) { setTimeout(tick, 100); return; }
      el.click();
      if (++i < steps.length) { setTimeout(tick, 60); return; }
      setTimeout(() => {
        const q = dialog.querySelector('[data-sf-view="quiz"] .jb-sf__quiz');
        if (q && !q.querySelector('.jb-nudge-said')) q.insertAdjacentHTML('afterbegin', `<p class="jb-sf__note jb-nudge-said">You told us your hair is ${NAMES[v]}.</p>`);
      }, 60);
    };
    tick();
  }
  // Finder page (/pages/find-my-shade, /pages/color-quiz-popup): the finder is already open on the page
  const pageFinder = () => {
    const d = document.querySelector('[data-fsp-finder]');
    if (d && !host()) prefill(d);
  };

  /* ------------------------------------------------ Klaviyo popup bridge */
  const HAIR = [
    [/blonde/i, 'blonde'],
    [/gr[ae]y|silver/i, 'gray'],
    [/red|auburn/i, 'red'],
    [/black/i, 'black'],
    [/brunette|brown/i, '']
  ];
  const inKlaviyo = (el) => !!(el && el.closest && el.closest('[class*="klaviyo"], [data-testid*="klaviyo"], .needsclick'));
  let klOpen = 0;
  let klEmail = false;
  let klHandoff = false;

  const hairFrom = (txt) => {
    for (const [re, v] of HAIR) if (re.test(txt)) return v;
    return null;
  };

  // Hair color answers and "TAKE THE QUIZ" (capture phase, before Klaviyo's own handler)
  window.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('button, a');
    if (!btn || !inKlaviyo(btn)) return;
    const txt = (btn.textContent || '').trim();
    if (txt.length < 40) {
      const v = hairFrom(txt);
      if (v !== null && !/thanks|browsing/i.test(txt)) {
        ss.set('jb-sf-hair', v);
        ss.set('jb-kl-hair', v || 'brunette');
        return;
      }
    }
    if (/take the quiz/i.test(txt) && hasFinder()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      klHandoff = true;
      closeKlaviyo(btn);
      setTimeout(openFinder, 250);
    }
  }, true);

  function closeKlaviyo(from) {
    const root = (from && from.closest('[role="dialog"]')) || document;
    const x = root.querySelector('button.klaviyo-close-form, button[aria-label="Close dialog"]');
    if (x) x.click();
  }

  window.addEventListener('klaviyoForms', (e) => {
    const d = (e && e.detail) || {};
    if (d.type === 'open') { klOpen++; hideBubble(); }
    if (d.type === 'submit') klEmail = true;
    if (d.type === 'close') {
      klOpen = Math.max(0, klOpen - 1);
      // Email given but the popup never showed her shades: show them now, here
      if (klEmail && !klHandoff && hasFinder()) { klHandoff = true; setTimeout(openFinder, 300); return; }
      if (pending) setTimeout(() => tryShow(pending), 2500);
    }
  });
  const klVisible = () => klOpen > 0 || [...document.querySelectorAll('[role="dialog"]')].some((d) => inKlaviyo(d) && d.getClientRects().length > 0);

  /* ------------------------------------------------ styles (card + bubble) */
  function css() {
    if (document.getElementById('jb-nudge-css')) return;
    const st = document.createElement('style');
    st.id = 'jb-nudge-css';
    st.textContent = `
.jb-sfcta { position: absolute; left: 0; right: 0; bottom: 0; box-sizing: border-box; display: flex; align-items: center; gap: 10px; width: 100%; height: 64px; padding: 0 10px; border: 2px solid var(--jb-blush-strong, #f1cde1); border-radius: var(--jb-radius, 14px); background: var(--jb-tint-100, #fceef5); color: var(--jb-ink, #2a2a2a); font: inherit; text-align: left; cursor: pointer; }
.jb-sfcta:hover { border-color: var(--jb-cta, #c72375); }
.jb-sfcta:focus-visible { outline: 3px solid var(--jb-focus, #2a2a2a); outline-offset: 2px; }
.jb-sfcta__txt { display: grid; gap: 1px; min-width: 0; font-size: 14px; line-height: 1.25; }
.jb-sfcta__txt strong { font-weight: 700; font-size: 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.jb-sfcta__go { margin-left: auto; flex: none; display: inline-flex; align-items: center; gap: 4px; height: 40px; padding: 0 12px; border-radius: 999px; background: var(--jb-cta, #c72375); color: #fff; font-weight: 700; font-size: 15px; line-height: 1; white-space: nowrap; }
.jb-sfcta__go svg { width: 16px; height: 16px; }
.jb-sfcta__go b { font-weight: 700; }
@media (max-width: 559px) { .jb-sfcta__go { width: 40px; padding: 0; justify-content: center; } .jb-sfcta__go b { display: none; } }
.jb-sw3 { display: flex; flex: none; }
.jb-sw3 span { width: 32px; height: 32px; border-radius: 50%; border: 2px solid #fff; background: var(--jb-tint-50, #fdf6fa) center / cover no-repeat; box-shadow: 0 1px 3px rgba(42, 42, 42, .18); }
.jb-sw3 span + span { margin-left: -12px; }
@media (max-width: 359px) { .jb-sfcta .jb-sw3 span:nth-child(n+2) { display: none; } }

.jb-nudge { position: fixed; z-index: 45; left: 12px; right: 12px; bottom: calc(12px + env(safe-area-inset-bottom, 0px)); max-width: 380px; padding: 14px 14px 14px 16px; border-radius: 18px; background: #fff; color: var(--jb-ink, #2a2a2a); box-shadow: 0 12px 34px rgba(42, 42, 42, .22), 0 0 0 1px rgba(199, 35, 117, .14); font: 15px/1.35 var(--jb-body, 'Open Sans', sans-serif); transform: translateY(calc(100% + 24px)); transition: transform .35s cubic-bezier(.2, .9, .3, 1.15); }
.jb-nudge.is-on { transform: none; }
html.jb-sticky-on .jb-nudge { bottom: calc(84px + env(safe-area-inset-bottom, 0px)); }
.jb-nudge__top { display: flex; align-items: center; gap: 12px; padding-right: 40px; }
.jb-nudge__h { margin: 0; font: 700 17px/1.25 var(--jb-head, 'Poppins', sans-serif); }
.jb-nudge__p { margin: 2px 0 0; color: var(--jb-ink-2, #4a4a4a); }
.jb-nudge__btn { box-sizing: border-box; text-decoration: none; display: flex; align-items: center; justify-content: center; gap: 6px; width: 100%; min-height: 48px; margin-top: 12px; padding: 0 16px; border: 0; border-radius: 999px; background: var(--jb-cta, #c72375); color: #fff; font: 700 16px/1.1 var(--jb-body, sans-serif); cursor: pointer; }
.jb-nudge__btn:hover { background: var(--jb-cta-hover, #ae1360); }
.jb-nudge__btn svg { width: 16px; height: 16px; }
.jb-nudge__note { margin: 8px 0 0; text-align: center; font-size: 13px; color: var(--jb-ink-2, #4a4a4a); }
.jb-nudge__x { position: absolute; top: 6px; right: 6px; display: grid; place-items: center; width: 44px; height: 44px; padding: 0; border: 0; border-radius: 50%; background: none; color: var(--jb-ink, #2a2a2a); cursor: pointer; }
.jb-nudge__x span { display: grid; place-items: center; width: 32px; height: 32px; border-radius: 50%; background: var(--jb-tint-100, #fceef5); }
.jb-nudge__x svg { width: 16px; height: 16px; }
.jb-nudge__x:hover span { background: var(--jb-blush-strong, #f1cde1); }
.jb-nudge button:focus-visible { outline: 3px solid var(--jb-focus, #2a2a2a); outline-offset: 2px; }
@media (min-width: 1000px) { .jb-nudge { left: 24px; right: auto; bottom: 24px; width: 360px; } }
@media (prefers-reduced-motion: reduce) { .jb-nudge { transition: none; } }
`;
    document.head.appendChild(st);
  }

  const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const XICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>';

  /* Three real swatch photos from this page, overlapped (best sellers first) */
  function swatches() {
    const h = host();
    if (!h) return '';
    const imgs = [...h.querySelectorAll('.jb-shade.is-bestseller .jb-shade__img img'), ...h.querySelectorAll('.jb-shade .jb-shade__img img')];
    const seen = new Set();
    const urls = [];
    for (const im of imgs) {
      const u = im.currentSrc || im.src;
      if (!u || seen.has(u)) continue;
      seen.add(u);
      urls.push(u);
      if (urls.length === 3) break;
    }
    if (!urls.length) return '';
    return `<span class="jb-sw3" aria-hidden="true">${urls.map((u) => `<span style="background-image:url('${u.replace(/'/g, '%27')}')"></span>`).join('')}</span>`;
  }

  /* ------------------------------------------------ 1. help card under the swatches */
  function addCard() {
    const h = host();
    const box = h && h.querySelector('.jb-shades');
    if (!box || box.querySelector('[data-jb-sfcta]')) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'jb-sfcta';
    b.setAttribute('data-jb-sfcta', '');
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = `${swatches()}<span class="jb-sfcta__txt"><strong>Not sure which shade?</strong><span>Find your match in 30 seconds</span></span><span class="jb-sfcta__go" aria-hidden="true"><b>Find my shade</b>${ARROW}</span>`;
    b.addEventListener('click', () => { hideBubble(); openFinder(); });
    box.appendChild(b);
  }

  /* ------------------------------------------------ 2. help bubble */
  let bubble = null;
  let pending = '';
  let waits = 0;

  const skipPage = () => /[?&]view=messy-bun-control\b/.test(location.search)
    || /^\/(cart|account|checkout|pages\/(find-my-shade|color-quiz|build-your-bundle))/.test(location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, ''));
  function blocked() {
    if (ss.get('jb-nudge')) return true;
    if (Number(ls.get('jb-nudge-no') || 0) >= 2) return true;
    if (Date.now() - Number(ls.get('jb-nudge-no-at') || 0) < 3 * 864e5) return true;
    if (skipPage()) return true;
    if (hasMemory()) return true;
    const f = finderEl();
    return !!(f && f.open);
  }
  function hasMemory() {
    try {
      const o = JSON.parse(ls.get('jb-shade-match') || 'null');
      return !!(o && Array.isArray(o.items) && o.items.length);
    } catch (e) { return false; }
  }

  function build(why) {
    const said = ss.get('jb-kl-hair');
    const names = { blonde: 'blonde', gray: 'gray or silver', red: 'red or auburn', black: 'black', brunette: 'brunette' };
    let h = 'Not sure which shade?';
    let p = "We'll find your match in 30 seconds.";
    if (why === 'compare') { h = 'Torn between shades?'; p = "We'll tell you which one matches your hair."; }
    if (said && names[said]) { h = `You said ${names[said]} hair.`; p = "Let's find your exact shade."; }
    const el = document.createElement('div');
    el.className = 'jb-nudge';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Shade help');
    el.setAttribute('data-jb-nudge-view', why);
    el.innerHTML = `
      <div class="jb-nudge__top">${swatches()}<div><p class="jb-nudge__h">${h}</p><p class="jb-nudge__p">${p}</p></div></div>
      ${hasFinder() ? `<button type="button" class="jb-nudge__btn" data-jb-nudge="find">Find my shade ${ARROW}</button>`
        : `<a class="jb-nudge__btn" href="/pages/find-my-shade" data-jb-nudge="find">Find my shade ${ARROW}</a>`}
      <p class="jb-nudge__note">Photo or 3 quick questions. Easy shade exchange.</p>
      <button type="button" class="jb-nudge__x" data-jb-nudge="no" aria-label="No, thanks"><span>${XICON}</span></button>`;
    el.addEventListener('click', (e) => {
      const b = e.target.closest('[data-jb-nudge]');
      if (!b) return;
      if (b.dataset.jbNudge === 'find' && b.tagName === 'BUTTON') openFinder();
      if (b.dataset.jbNudge === 'no') { ls.set('jb-nudge-no', String(Number(ls.get('jb-nudge-no') || 0) + 1)); ls.set('jb-nudge-no-at', String(Date.now())); hideBubble(); }
    });
    el.addEventListener('keydown', (e) => { if (e.key === 'Escape') hideBubble(); });
    return el;
  }

  function tryShow(why) {
    if (bubble || blocked()) { pending = ''; return; }
    const wait = 4000 - (Date.now() - t0);
    if (wait > 0) { pending = why; setTimeout(() => tryShow(why), wait); return; }
    if (klVisible() || document.visibilityState === 'hidden') {
      pending = why;
      if (++waits < 20) setTimeout(() => { if (pending) tryShow(pending); }, 4000);
      return;
    }
    pending = '';
    css();
    ss.set('jb-nudge', '1');
    bubble = build(why);
    document.body.appendChild(bubble);
    requestAnimationFrame(() => requestAnimationFrame(() => bubble && bubble.classList.add('is-on')));
  }

  function hideBubble() {
    if (!bubble) return;
    const b = bubble;
    bubble = null;
    b.classList.remove('is-on');
    setTimeout(() => b.remove(), 400);
  }

  function initBubble() {
    const h = host();
    if (!h || blocked()) return;
    // Opened the finder or added to cart: no bubble this session
    h.addEventListener('click', (e) => {
      if (e.target.closest('[data-open-finder], [data-atc], [data-sticky-btn]')) { ss.set('jb-nudge', '1'); hideBubble(); }
    });
    h.addEventListener('submit', () => { ss.set('jb-nudge', '1'); hideBubble(); });

    // a) comparing: a 2nd different shade picked by hand
    const picked = new Set();
    h.addEventListener('change', (e) => {
      const i = e.target.closest && e.target.closest('[data-shade-input]');
      if (!i) return;
      picked.add(i.value);
      if (picked.size >= 2) setTimeout(() => tryShow('compare'), 1500);
    });

    document.addEventListener('visibilitychange', () => { if (pending && document.visibilityState === 'visible') setTimeout(() => tryShow(pending), 1500); });
  }

  /* Home, collections and other pages: no bubble (no timers, Amit 2026-10-19) */
  function initOther() { /* nothing */ }

  const init = () => {
    pageFinder();
    const h = host();
    if (!h || !window.customElements) { initOther(); return; }
    // This file runs before the product page script defines <jb-pdp> / <jb-pdp-gen>
    customElements.whenDefined(h.localName).then(() => {
      if (!hasFinder()) return;
      css();
      addCard();
      // The page's own "Find my shade" buttons also get the hair color from the popup
      h.addEventListener('click', (e) => { if (e.target.closest('[data-open-finder]')) prefill(finderEl()); });
      initBubble();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
